import { render, staticRenderFns } from "./MdUploadFile.vue?vue&type=template&id=5d7c453e&"
import script from "./MdUploadFile.vue?vue&type=script&lang=js&"
export * from "./MdUploadFile.vue?vue&type=script&lang=js&"
import style0 from "./MdUploadFile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports